import api from "./api";

const users = {}
/*
Функция отправляет данные для входа на сервер и возвращает Promise с ответом с севера
*/
users.login = function(credentials, token = ""){
  return api.post('/api/users/login', credentials, token)
}
/*
  Функция отправляет на сервер запрос на выход и возвращает Promise с результатом: ok - успешное завершение
*/
users.logout = function(){
  return api.post('/api/users/logout')
}
/*
  Функция отправляет на сервер запрос на добавление нового пользователя
*/
users.save = function save(credentials, token = ""){
  return api.post('/api/users/save', credentials, token)
}

users.update = function update(credentials, userId, token = ""){
  let request = '/api/users/' + userId + '/update';
  return api.post(request, {...credentials, id: userId}, token)
}

users.delete = function deleteUser(userId, token = ""){
  let request = '/api/users/' + userId + '/delete';
  return api.post(request, {}, token);
}

export default users;